const PushConsentTypes = [
    "VARSLER",
    "TIPS",
    "TILBUD",
    //"NETTHANDEL", // Hidden until service is ready
    "BESPAR",
]

export default PushConsentTypes
